import { useNumericParams } from '@domain-group/react-hooks'

import useAgency from '@hooks/useAgency'
import useReduxAction from '@hooks/useReduxAction'

import { ModuleState } from '@redux/modules/module'

import ProviderAgencyEditRoutes from './routes'

const ProviderAccountEdit = () => {
  const { agencyId } = useNumericParams()

  useReduxAction(
    'agencies',
    'loadAgency',
    {
      entityId: agencyId,
      include_agency_brand: true,
      include_agency_provider_account_for_provider: true,
      include_agency_provider_metrics: true,
      include_brand_logo: true,
      include_provider_account_provider: true,
      include_provider_is_publication_provider: true,
    },
    [agencyId],
    {
      dispatchAction: (action, requestOptions) => action(agencyId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }: ModuleState) => agencyId && !loading,
    },
  )

  const { agency, providerAccount } = useAgency({ id: agencyId })

  return (
    // @ts-expect-error TS2322
    <ProviderAgencyEditRoutes agency={agency} providerAccount={providerAccount} />
  )
}

export default ProviderAccountEdit
